
    // this file was auto generated by python script
    import Square from './Square';
    export default Square;
    